import { render, staticRenderFns } from "./ServiceUpDia.vue?vue&type=template&id=9ac68df6&scoped=true"
import script from "./ServiceUpDia.vue?vue&type=script&lang=js"
export * from "./ServiceUpDia.vue?vue&type=script&lang=js"
import style0 from "./ServiceUpDia.vue?vue&type=style&index=0&id=9ac68df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac68df6",
  null
  
)

export default component.exports